import React,{useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import TvDetails from '../components/Details/TvDetails';
import TvVideos from '../components/MovieVideos/TvVideos';
import {fetchData, fetchData2} from '../Utils/FetchData'
import {motion} from 'framer-motion'
import SimilarTv from '../components/Similar/SimilarTv';

function TvshowDetails() {
  const [currentShow, setCurrentShow] = useState({})
  const [tvTrailer, setTvTrailer] = useState([])
  const [playTrailer, setPlaytrailer] = useState(false)
  const [similarTvs, setSimilarTvs] = useState([]) 

  const play = () => {
    setPlaytrailer(true)
  }

  const stop =() => {
    setPlaytrailer(false)
  }
    const {id} = useParams();

    useEffect(()=>{
      const tvDetail = async () => {
        const dataMovie = await fetchData2(`https://api.themoviedb.org/3/tv/${id}?api_key=f1495476b28b6efe4e4d6d815c2eb1e9`);
        setCurrentShow(dataMovie)
      
      const trailer = await fetchData(`https://api.themoviedb.org/3/tv/${id}/videos?api_key=f1495476b28b6efe4e4d6d815c2eb1e9`)
      setTvTrailer(trailer)

      const similarTv = await fetchData(`https://api.themoviedb.org/3/tv/${id}/similar?api_key=f1495476b28b6efe4e4d6d815c2eb1e9`)
      setSimilarTvs(similarTv)
    }
      tvDetail()
    }, [id])
  return (
    <motion.div
    initial={{width:0}}
    animate={{width:"100%"}}
    exit={{x:window.innerWidth, tranition: {duration:  0.1}}}
    style={{padding:'10px 20px'}}>
      <TvDetails currentShow={currentShow} play={play}/>
      <TvVideos tvTrailer={tvTrailer} playTrailer={playTrailer} stop={stop}/>
      <SimilarTv similartvs={similarTvs} />
    </motion.div>
  )
}

export default TvshowDetails



